import { useCommunityContext } from '@/providers/community-context';
import { GivesAsksView } from './gives-asks-view';

export default function GivesAsksPage() {
  const { community } = useCommunityContext();

  if (!community.isGivesAsksEnabled) {
    return (
      <div className="mx-auto max-w-2xl rounded-2xl border bg-white p-8 text-center text-sm text-muted-foreground">
        Gives & Asks is not enabled for this community.
      </div>
    );
  }

  return <GivesAsksView communityId={community.id} />;
}
